if (!customElements.get('adev-main-collection')) {
    customElements.define('adev-main-collection', class adevMainCollection extends HTMLElement {
        constructor() {
            super();
        }

        loading(isLoading = true) {
            this.classList.toggle('adev--is-loading', isLoading);
        }

        initFacets(){
            const facets = this.querySelector('adev-facets');
            if (facets) {
                const form = facets.querySelector('form');
                facets.addEventListener('adev:change', () => {

                    this.loading(true);

                    const url = new URL(window.location);
                    const params = new URLSearchParams(new FormData(form));
                        
                    url.search = params.toString();
                        history.pushState({}, '', url);

                    fetch(url, {
                        method: 'GET',
                    })
                    .then(response => response.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');
                        const mainContents = doc.querySelector('[data-adev-main-collection="inner"]');

                        const mainEl = this.querySelector('[data-adev-main-collection="inner"]');
                        if (mainContents) {
                            mainEl.replaceWith(mainContents);
                            this.initFacets();
                        }
                    })
                    .finally(() => {
                        this.loading(false);
                    });

                });
            }
        }

        connectedCallback() {
            this.initFacets();
        }

        disconnectedCallback() {
            
        }

    });
}